import _ from 'lodash';
import Promise from 'bluebird';
import {
    generateResourceStore,
    generateResourceGetters,
    generateResourceActions,
    generateResourceMutations,
} from '../generators';

// initial state
const createState = (helpers) => {
    return Promise.resolve({
        ...generateResourceStore(),
    });
}

// getters
const getters = {
    ...generateResourceGetters(),
}

// actions
const createActions = (helpers) => ({
    ...generateResourceActions(helpers),

    getInitialData({ commit }, url) {
        const path = helpers.uriFormat(url);
        commit('setPath', path);
        commit('processing');

        return helpers.api.getData(path)
            .then(res => {
                commit('setContent', res);
            })
            .finally(() => commit('idle'))
    }
})

// mutations
const mutations = {
    ...generateResourceMutations(),
}

export default (helpers) => {
    return Promise.all([
        createState(helpers),
        createActions(helpers),
    ])
        .then(([state, actions]) => ({
            namespaced: true,
            state,
            getters,
            actions,
            mutations,
        }))
}



// WEBPACK FOOTER //
// ./seventytwo/72cms-ui/src/store/modules/sub.js